import { Tag } from "features/shared/types/tag";
import { Article } from "../types/article";

interface Props {
    fields: Article;
    tags: Tag[];
}

export const verifyForm = ({ fields, tags }: Props) =>
    new Promise(
        (resolve: (res: string) => void, reject: (err: string) => void) => {
            if (!fields.type) reject("Type not provided");

            if (!fields.properties.name?.en)
                reject("English name not provided");
            if (!fields.properties.name?.th) reject("Thai name not provided");

            if (fields.tags.length) {
                const tagKeys = tags.map((tag) => tag.key);

                fields.tags.forEach((tag) => {
                    if (!tagKeys.includes(tag))
                        reject(`Tag key '${tag}' does not exist!`);
                });
            }

            resolve("Success");
        }
    );
